export const DEFAULT_INITIAL_WEIGHT_LB = 250;
export const ESTIMATED_WEIGHT_LOSS_PERCENTAGE_BY_WEEK = [
  [0, 0],
  [4, 0.02],
  [8, 0.04],
  [12, 0.06],
  [16, 0.078],
  [20, 0.094],
  [28, 0.117],
  [36, 0.132],
  [44, 0.142],
  [52, 0.148]
];

export const ESTIMATED_WEIGHT_LOSS_PERCENTAGE_BY_FOUR_WEEKS = [
  [0, 0],
  [4, 0.02],
  [8, 0.04],
  [12, 0.06],
  [16, 0.078],
  [20, 0.094],
  [24, 0.106],
  [28, 0.117],
  [32, 0.125],
  [36, 0.132],
  [40, 0.137],
  [44, 0.142],
  [48, 0.145],
  [52, 0.148]
];

// Unified quiz offer types
export const CORE = "CORE";
export const WORKSHOPS = "WORKSHOPS";
export const CLINICAL = "CLINICAL";

// Cookies
export const WWFTM = "wwftm";
